import { render, staticRenderFns } from "./CoachDetailTop.vue?vue&type=template&id=0d10c95f&scoped=true&lang=pug"
import script from "./CoachDetailTop.vue?vue&type=script&lang=js"
export * from "./CoachDetailTop.vue?vue&type=script&lang=js"
import style0 from "./CoachDetailTop.vue?vue&type=style&index=0&id=0d10c95f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10c95f",
  null
  
)

export default component.exports